import glamorous from 'glamorous';
import React from 'react';
import { ColumnsUtils, createPureComponent } from 'module/Common';
import { ContentRichText } from 'module/Model/Content';
import { LocalizedContent, RichText as RichTextRender, Sizes } from 'module/View/Common';

type Props = {
  item: ContentRichText;
  itemIndex: number;
  isCover: boolean;
  cols: ColumnsUtils.ColumnsResult;
  waitForImage: (id: string) => void;
  imageReady: (id: string) => void;
};

const Wrapper = glamorous.div<{ width: number }>(({ width }) => ({
  width,
  pointerEvents: 'all',
}));

export const RitchText = createPureComponent<Props>('RitchText', ({ item, itemIndex, isCover, cols }) => {
  const isFullWidth = ContentRichText.isFullWidth(item);
  const theWidth =
    isFullWidth && !isCover ? cols.size(cols.nbOfColumns) : cols.size(Sizes.allColumnsMinusOne(cols.nbOfColumns));
  return (
    <Wrapper width={theWidth}>
      <LocalizedContent content={ContentRichText.getContent(item)}>
        {content => <RichTextRender content={content} />}
      </LocalizedContent>
    </Wrapper>
  );
});



// WEBPACK FOOTER //
// ./src/module/View/Content/component/ContentItems/items/RichText.tsx